import ApiUtils from "@/plugins/ApiPlugin/ApiUtils"


export default {
  install(app, options = {}) {
    app.config.globalProperties.$api = ApiUtils
  }
}
